import React from 'react';
import { withRouter } from 'react-router-dom';
import { Translation } from 'react-i18next';
import { throttle, get, pull } from 'lodash';
import { connect } from 'react-redux';
import withStyles from 'react-jss';
import {
  getAuthState,
  getTenantState,
  getEcapState,
  getOnboardingState,
} from '../../store/selectors';
import {
  updateUserProgress,
  getUserData,
  getTenantHSClassesForAcadplans,
} from '../../store/actions';
import Scrollbar from '../Scrollbar';
import AchievementsIcon from '../../ASUPhotos/icons/me3_ECAP_Achievements_Icon.svg';
import ClassesIcon from '../../ASUPhotos/icons/me3_ECAP_Classes_Icon.svg';
import StatisticsIcon from '../../ASUPhotos/icons/me3_ECAP_Statistics_Icon.svg';
import UniversityIcon from '../../ASUPhotos/icons/me3_ECAP_University_Icon.svg';
import ScrollToTop from '../utility/ScrollToTop';
import SetUpClasses from './SetUpClasses';
import ChooseCareerPath from './ChooseCareerPath';
import AdditionalActivities from './AdditionalActivities';
import AcademicStatistics from './AcademicStatistics';
import CompletePlan from './CompletePlan';
import HeaderWithHamburger from '../utility/HeaderWithHamburger';
import { getHeaderListItems } from '../utility/headerUtil';
import DegreeRequirements from './degree-requirements/DegreeRequirements';
import { handleFireGTM } from '../utility/routeUtil';
import WindowTitle from '../utility/WindowTitle';

const continueButtonStyles = {
  color: (props) => ({
    backgroundColor: props.tenant ? props.tenant.primary : 'white',
    borderColor: props.tenant ? props.tenant.primary : 'black',
    marginTop: '10px',

    '&:hover': {
      backgroundColor: 'white',
      border: props.tenant
        ? `2px solid ${props.tenant.primary}`
        : '2px solid black',
      color: props.tenant ? props.tenant.primary : 'black',
      borderStyle: 'solid',
    },
  }),
};

export class NavBarParent extends React.Component {
  _isMounted = false;

  constructor(props) {
    super(props);

    this.setUpClasses = React.createRef();
    this.chooseCareerPath = React.createRef();
    this.additionalActivities = React.createRef();
    this.academicStatistics = React.createRef();
    this.pageContent = React.createRef();
    this.header = React.createRef();
    this.completePlanButton = React.createRef();

    this.state = {
      progress: '1/4',
      activeElement: 'Classes',
      setUpClassesEnd: null,
      chooseCareerPathStart: null,
      chooseCareerPathEnd: null,
      additionalActivitiesStart: null,
      academicStatisticsStart: null,
      academicStatisticsEnd: null,
      displayCompletePlan: false,
      saveStatus: 'Save',
      showDegreeRequirements: false,
      mobileSearchMode: false,
      careerIndex: 1,
      currentDegree: null,
      acadPlanClasses: null,
    };
  }

  colorPrimary = {
    color: `${this.props.tenant.primary}`,
  };

  backgroundPrimary = {
    backgroundColor: `${this.props.tenant.primary}`,
  };

  backgroundSecondary = {
    backgroundColor: `${this.props.tenant.secondary}`,
  };

  borderBottom = {
    borderBottom: `4px solid ${this.props.tenant.secondary}`,
  };

  navBarIcon = {
    height: '27px',
    width: '25px',
  };

  display = {
    display: 'flex',
  };

  doNotDisplay = {
    display: 'none',
  };

  borderTopSecondary = {
    borderTop: `9px solid ${this.props.tenant.secondary}`,
  };

  get actionPlanCareer() {
    let foundCareer;

    Object.values(this.props.onboarding.careerChoices).forEach((career) => {
      if (career.id === this.props.ecap.actionPlan.action_plan_career_id)
        foundCareer = career;
    });

    return foundCareer;
  }

  get currentCareer() {
    return this.props.ecap.actionPlan.action_plan_career_id !== null
      ? this.actionPlanCareer
      : this.props.onboarding.careerChoices[this.state.careerIndex];
  }

  updateCurrentDegree = () => {
    if (
      this.state.currentDegree === null ||
      this.state.currentDegree.id !==
        this.props.onboarding.careerChoices[this.state.careerIndex].degreeId
    ) {
      const careerDegree =
        this.props.ecap.actionPlan.action_plan_career_id !== null
          ? this.actionPlanCareer
          : this.props.onboarding.careerChoices[this.state.careerIndex]
              .degreeId;

      let currentDegree;

      Object.values(this.props.onboarding.degreeChoices).forEach(
        (eachDegree) => {
          if (eachDegree.id === careerDegree) {
            currentDegree = eachDegree;
          }
        }
      );
      this.setState({ currentDegree });
    }
    return this.state.currentDegree;
  };

  setCareerIndex = (careerIndex) => {
    this.setState({ careerIndex });
  };

  componentDidMount = async () => {
    this._isMounted = true;
    await this.props.getUserData(
      this.props.onboarding.userData.user.id,
      this.props.auth.jwtToken
    );

    const acadPlanClasses = await this.props.getTenantHSClassesForAcadplans(
      this.props.tenant.id,
      this.acadPlansArray
    );

    await this.updateCurrentDegree();

    const setUpClassesStart = 0;
    const setUpClassesEnd =
      setUpClassesStart + this.setUpClasses.current.clientHeight;
    const academicStatisticsStart = setUpClassesEnd + 1;
    const academicStatisticsEnd =
      academicStatisticsStart + this.academicStatistics.current.clientHeight;
    const chooseCareerPathStart = academicStatisticsEnd + 1;
    const chooseCareerPathEnd =
      chooseCareerPathStart + this.chooseCareerPath.current.clientHeight;
    const additionalActivitiesStart = chooseCareerPathEnd + 1;

    this.setState({
      setUpClassesEnd,
      academicStatisticsStart,
      academicStatisticsEnd,
      chooseCareerPathStart,
      chooseCareerPathEnd,
      additionalActivitiesStart,
      acadPlanClasses,
    });
  };

  componentDidUpdate() {
    this.updateCurrentDegree();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  get acadPlansArray() {
    return Object.values(this.props.onboarding.degreeChoices).map(
      (degree) => degree.acadPlan
    );
  }

  get tenantName() {
    return this.props.tenant.name;
  }

  get onboarding() {
    return this.props.onboarding;
  }

  get educationLevel() {
    return get(this.onboarding, 'userData.user.educationLevel');
  }

  handleScrollDownSelect = async (ref) => {
    await ref.current.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
    if (ref.current.id !== 'completePlan') {
      setTimeout(() => {
        document.getElementById(`component-header-${ref.current.id}`).focus();
      }, 700);
    }
  };

  displayNavBarElement(img, label, ref, activeElement) {
    return (
      <button
        type="button"
        className={`navbar-icon-box ${label}`}
        data-cy={label}
        aria-label={`Jump to ${label} section`}
        onClick={() => {
          this.handleScrollDownSelect(ref);
        }}
        aria-current={label === activeElement && 'step'}
      >
        <img alt={`icon for ${label}`} src={img} style={this.navBarIcon} />
        <p
          className="navbar-label"
          style={label === activeElement ? this.borderBottom : null}
        >
          {label}
        </p>
      </button>
    );
  }

  updateMobileSearchMode = (bool) => {
    this.setState({
      mobileSearchMode: bool,
    });
  };

  handleScrollToTop = () => {
    this.setUpClasses.current.scrollIntoView({
      behavior: 'smooth',
    });
  };

  handleScroll = (vals) => {
    const {
      setUpClassesEnd,
      academicStatisticsStart,
      academicStatisticsEnd,
      chooseCareerPathStart,
      chooseCareerPathEnd,
      additionalActivitiesStart,
      activeElement,
    } = this.state;

    const currentPlace = vals.scrollTop + vals.clientHeight / 2;

    let currentlyActiveElement;
    let progress;

    if (currentPlace <= setUpClassesEnd) {
      currentlyActiveElement = 'Classes';
      progress = '1/4';
    } else if (
      currentPlace > academicStatisticsStart &&
      currentPlace <= academicStatisticsEnd
    ) {
      currentlyActiveElement = 'Statistics';
      progress = '2/4';
    } else if (
      currentPlace > chooseCareerPathStart &&
      currentPlace <= chooseCareerPathEnd
    ) {
      currentlyActiveElement = 'University';
      progress = '3/4';
    } else if (currentPlace >= additionalActivitiesStart) {
      currentlyActiveElement = 'Activities';
      progress = '4/4';
    }

    if (activeElement !== currentlyActiveElement) {
      if (this._isMounted) {
        this.setState({
          activeElement: currentlyActiveElement,
          progress,
        });
      }
    }
  };

  saveProgress = async () => {
    if (this._isMounted) {
      this.setState({
        saveStatus: 'Saving...',
      });
      setTimeout(this.saveMessage, 2000);

      handleFireGTM(
        this.props.tenant.name,
        'click "complete my plan" from additional activities',
        this.props.location.pathname
      );

      await this.careerPath.saveProgress();
      await this.activities.saveProgress();
      await this.statistics.submitPlan();
      if (!this.props.onboarding.userData.userProgress.started_ecap) {
        await this.props.updateUserProgress(this.props.auth.jwtToken, {
          started_ecap: true,
        });
      }
    }
  };

  closeCompletePlan = () => {
    this.setState({
      displayCompletePlan: false,
    });
  };

  handleClick = (e) => {
    if (
      this.node.contains(e.target) &&
      this.state.displayCompletePlan === true &&
      !this.pdf.contains(e.target)
    ) {
      this.closePDF();
    }
  };

  displayCompletePlan = async () => {
    if (!this.props.onboarding.userData.userProgress.completed_ecap) {
      await this.props.updateUserProgress(this.props.auth.jwtToken, {
        completed_ecap: true,
      });
    }
    this.setState({
      displayCompletePlan: true,
    });
    // Do not focus on button to let voice over announce any kind of assertion
    // document.getElementById('complete-plan-modal-actions-button').focus();
  };

  saveMessage = () => {
    if (this._isMounted) {
      this.setState({
        saveStatus: 'Saved',
      });

      setTimeout(this.defaultMessage, 2000);
    }
  };

  defaultMessage = () => {
    if (this._isMounted) {
      this.setState({
        saveStatus: 'Save',
      });
    }
  };

  closeDegreeRequirements = () => {
    if (this._isMounted) {
      this.setState({
        showDegreeRequirements: false,
      });
    }
  };

  getDynamicButton = () => {
    const temporaryValid = true;

    return temporaryValid ? this.props.classes.color : null;
  };

  setShowDegree = () => {
    this.setState({
      showDegreeRequirements: true,
    });
  };

  getNavBarStyle = () => {
    return this.state.mobileSearchMode
      ? { display: 'none' }
      : { display: 'initial' };
  };

  getListItems = () => {
    return getHeaderListItems({
      educationLevel: this.graduationYear,
      tenantName: this.tenantName,
    });
  };

  render() {
    const { activeElement, saveStatus, displayCompletePlan } = this.state;

    const saveStyle = activeElement === 'Classes' ? { display: 'none' } : {};
    return (
      <Translation>
        {(t) => (
          <>
            <WindowTitle>{t('Education and Career Action Plan')}</WindowTitle>
            <div className="ecap-parent">
              {this.state.showDegreeRequirements && (
                <div
                  style={
                    this.state.showDegreeRequirements
                      ? this.display
                      : this.doNotDisplay
                  }
                  className="degree-requirements-container"
                >
                  {this.state.currentDegree && (
                    <DegreeRequirements
                      degree={this.state.currentDegree}
                      acadPlanClasses={this.state.acadPlanClasses}
                      closeDegreeRequirements={this.closeDegreeRequirements}
                      type="modal"
                      focus={this.state.showDegreeRequirements}
                    />
                  )}
                </div>
              )}
              {displayCompletePlan ? (
                <CompletePlan
                  display={displayCompletePlan}
                  onClose={this.closeCompletePlan}
                  saveStatus={this.state.saveStatus}
                  closeModal={this.closePDF}
                  currentDegree={this.state.currentDegree}
                  acadPlanClasses={this.state.acadPlanClasses}
                />
              ) : null}
              <HeaderWithHamburger
                tenant={this.props.tenant}
                linkToDashboard
                listItems={this.getListItems()}
              />
              <div
                className="navbar-and-page-content"
                aria-hidden={displayCompletePlan}
              >
                <div
                  className="ecap-navbar-container"
                  style={this.getNavBarStyle()}
                >
                  <nav className="ecap-navbar">
                    <div
                      className="progress-box"
                      style={this.backgroundSecondary}
                    >
                      {this.state.progress}
                    </div>
                    {this.displayNavBarElement(
                      ClassesIcon,
                      t('Classes'),
                      this.setUpClasses,
                      activeElement
                    )}
                    {this.displayNavBarElement(
                      StatisticsIcon,
                      t('Statistics'),
                      this.academicStatistics,
                      activeElement
                    )}
                    {this.displayNavBarElement(
                      UniversityIcon,
                      t('University'),
                      this.chooseCareerPath,
                      activeElement
                    )}
                    {this.displayNavBarElement(
                      AchievementsIcon,
                      t('Activities'),
                      this.additionalActivities,
                      activeElement
                    )}
                  </nav>
                </div>
                <div
                  className="page-content"
                  id="pageContainer"
                  ref={this.pageContent}
                >
                  <Scrollbar
                    contentClassName="page-content-scrollable"
                    onScroll={throttle(this.handleScroll, 250)}
                  >
                    <div id="setUpClasses" ref={this.setUpClasses}>
                      <SetUpClasses
                        closeDegreeRequirements={this.closeDegreeRequirements}
                        currentCareer={this.currentCareer}
                        currentDegree={this.state.currentDegree}
                        scrollNext={() =>
                          this.handleScrollDownSelect(this.academicStatistics)
                        }
                        sendShowDegreeToParent={this.setShowDegree}
                        tenant={this.props.tenant}
                        updateMobileSearchMode={this.updateMobileSearchMode}
                        setCareerIndex={this.setCareerIndex}
                        careerIndex={this.state.careerIndex}
                        acadPlanClasses={this.state.acadPlanClasses}
                        acadPlansArray={this.acadPlansArray}
                      />
                    </div>
                    <div id="academicStatistics" ref={this.academicStatistics}>
                      <AcademicStatistics
                        tenant={this.props.tenant}
                        onRef={(ref) => {
                          this.statistics = ref;
                        }}
                        scrollNext={() =>
                          this.handleScrollDownSelect(this.chooseCareerPath)
                        }
                      />
                    </div>
                    <div id="chooseCareerPath" ref={this.chooseCareerPath}>
                      <ChooseCareerPath
                        tenant={this.props.tenant}
                        scrollNext={() =>
                          this.handleScrollDownSelect(this.additionalActivities)
                        }
                        onRef={(ref) => {
                          this.careerPath = ref;
                        }}
                      />
                    </div>
                    <div
                      id="additionalActivities"
                      ref={this.additionalActivities}
                    >
                      <AdditionalActivities
                        tenant={this.props.tenant}
                        scrollNext={() =>
                          this.handleScrollDownSelect(this.completePlanButton)
                        }
                        onRef={(ref) => {
                          this.activities = ref;
                        }}
                      />
                      <div className="complete-plan-button-container">
                        <button
                          ref={this.completePlanButton}
                          type="button"
                          onClick={async () => {
                            await this.saveProgress();
                            this.displayCompletePlan();
                          }}
                          onKeyDown={async (e) => {
                            if (['Enter'].includes(e.key)) {
                              await this.saveProgress();
                              this.displayCompletePlan();
                            }
                          }}
                          className={[
                            'button--primary',
                            this.getDynamicButton(),
                          ].join(' ')}
                          id="complete-plan-button"
                        >
                          {t('Complete My Plan!')}
                        </button>
                      </div>
                    </div>
                  </Scrollbar>
                </div>
              </div>
              <div className="scroll-to-top" aria-hidden={displayCompletePlan}>
                <div
                  style={saveStyle}
                  className="clickable-scroll"
                  role="button"
                  onClick={this.handleScrollToTop}
                  onKeyDown={(e) => {
                    if (['Enter'].includes(e.key)) this.handleScrollToTop();
                  }}
                  tabIndex={0}
                >
                  <ScrollToTop color={this.props.tenant.primary} />
                  <p className="scroll-text">{t('Scroll To Top')}</p>
                </div>
                <button
                  aria-label="Save your plan"
                  style={saveStyle}
                  type="submit"
                  className={['button--primary', this.getDynamicButton()].join(
                    ' '
                  )}
                  id="submit-button-save-ecap"
                  onClick={this.saveProgress}
                >
                  {saveStatus}
                </button>
              </div>
            </div>
          </>
        )}
      </Translation>
    );
  }
}

const mapStateToProps = (state) => {
  const auth = getAuthState(state);
  const tenant = getTenantState(state);
  const ecap = getEcapState(state);
  const onboarding = getOnboardingState(state);

  return { auth, tenant, ecap, onboarding };
};

const NavBarWithRouter = withRouter(
  connect(mapStateToProps, {
    updateUserProgress,
    getUserData,
    getTenantHSClassesForAcadplans,
  })(NavBarParent)
);

export default withStyles(continueButtonStyles)(NavBarWithRouter);
